import React, { useEffect, useState } from 'react'
import Select from 'meinian-package/src/baseComponent/select'

const convert = (result) => {
  return result.map(m => ({ label: m.name, value: m.name }))
}
export default (props) => {
  const [options, setOptions] = useState([])
  useEffect(() => {
    getMarkets()
  }, [])
  const getMarkets = async () => {
    try {
      const res = JSON.parse(sessionStorage.getItem('meinianFilters')).find(f => f.itemName === '批发市场')?.itemTreeValue.children
      setOptions(convert(res))
    } catch (err) {
      console.error(err)
    }
  }

  return <Select {...props} data={options} placeholder="不限" />
}
